<script>
  export let title = "The title";
  export let subtitle = "The subtitle";
  export let dark = false;
</script>

<div class="section-title" class:section-title--dark={dark}>
  <div class="section-title__title">{title.toLocaleUpperCase()}</div>
  <div class="section-title__subtitle">{subtitle}</div>
</div>

<style lang="scss">
  @import "./assets/styles/variables";

  $text-color-light: black;
  $text-color-dark: $color-orange-dark;

  .section-title {
    color: $text-color-light;
    margin: 8rem auto 0;
    text-align: center;

    &--dark {
      color: $text-color-dark;
    }

    &__title {
      font-family: "DecathlonBeta";
      font-size: 44px;
    }

    &__subtitle {
      font-family: "Roboto";
      font-weight: 100;
      font-size: 20px;
      text-transform: uppercase;
    }
  }
</style>
